_putUserProfileImages